import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import React from "react";
import style from "./LoadingOutline.module.css";
export function LoadingOutline(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(style["loading-box"], " ").concat(props.className)
  }, /*#__PURE__*/React.createElement(Spin, {
    indicator: /*#__PURE__*/React.createElement(LoadingOutlined, {
      style: {
        fontSize: props.size || 24
      },
      spin: true
    })
  }));
}